import request from '@/utils/request'

export function getRecentStats(minutes) {
  return request({
    url: '/api/admin/system-stats/recent',
    method: 'get',
    params: { minutes }
  })
}

export function getLatestStats() {
  return request({
    url: '/api/admin/system-stats/latest',
    method: 'get'
  })
}

export function getRealtimeStats() {
  return request({
    url: '/api/admin/system-stats/realtime',
    method: 'get'
  })
}
